export const MOBILE_NUMBER = "mobile_number";
export const REFERENCE_NUMBER = "reference_number";
export const REFERENCE_NUMBER_SUPPLIER = "reference_number_supplier";
export const OTP = "otp";
//basic information
export const LOAN_REQUEST_STATUS = "loan_request_status";
export const SUPPLIER_SETTLEMENT_STATUS = "supplier_settlement_status";
export const LOAN_REQUEST_SOURCE = "loan_request_source";
export const LOAN_TEMPLATES = "loan_template";
export const SUPPLIER_UESR = "supplier_user";
export const GET_STORE_BY_SUPPLIER = "get_store_by_supplier";
//
export const REQUEST_DETAIL = "request_detail";
export const REFRENCE_KEY = "refrence_Key";
export const SUPPLIER_CREDIT = "supplier_credit";
export const VALID_FORM = "valid_form";
export const GET_SUPPLIER_ATTACHMENT = "get_supplier_attachment";
export const NATIONAL_CODE = "national_code";
export const INSTALLMENT_COUNT = "installmen_count";
export const INSTALLMENT_STEP = "installmen_step";
export const GET_CUSTOMER_REGISTRATION_INFO = "get_customer_registration_info";
/* key of customer registration info*/
export const HAS_REGISTER_REQUEST = "has_register_request";
export const IS_EDITABLE = "is_editable";
//handle stepper
export const CURRENT_STATUS_STEPPERCMP = "current_status_steppercmp";
export const TABS_STEPPERCMP = "tabs_steppercmp";
export const LOAN_REQUEST_INFO_STEPPERCMP = "loan_request_info_steppercmp";
export const STEP_NUMBER = "step_number";
export const STEP_NUMBER_BACK = "step_number_back";
export const STEP_NUMBER_BACK_NAME = "step_number_back_name";
export const NEED_GURANTEE_CHEQUE = "need_guarantee_cheque";
export const NEED_INSTALLMENT_CHEQUES = "need_installment_cheques";

export const IS_CANCELABLE = "is_cancelable";
export const CUSTOMER_INFO = "customer_info";
export const LOAN_TEMPLATE_INFOS = "loan_template_infos";
export const EXISTING_LOANREQUEST = "existing_loanRequest";

export const WARRANTY_TAB = "warranty_tab";
/* id loan*/
export const LOAN_ID = "loan_id";
export const CANCELLOAN_REQUEST = "cancelLoan_request";
export const Timer_INIT = "timer_init";
export const VALUES_CONFIRM_FACILITY = "values_confirm_facility";

export const ENGLISH_FIRST_NAME = "english_first_name";
export const ENGLISH_LAST_NAME = "english_Last_name";
export const CUSTOMER_BIRTHDATE = "customer_birthDate";
export const CUSTOMER_MOBILENUMBER = "customer_mobileNumber";
export const LOAN_AMOUNT = "loan_amount";
export const POSTAL_CODE = "postal_Code";
export const INQUIRY_OTP_REF_KEY = "inquiry_otp_ref_key";
export const TEXT_DROPDOWN = "text_dropdown";
export const TABLE_FILTER = "table_filter";
export const TABLE_FILTER_ROWNumber = "table_filter_rownumber";
export const TABLE_FILTER_REGISTER = "table_filter_register";
export const TABLE_FILTER_SETTELMENT = "table_filter_settelment";

export const DEL_CHIP = "del_chip";
/* SupplierUser*/
export const SUPPLIER_USER_INFO = "supplier_user_info";
export const TEST = "test";

// Attachments tab
export const JOBINCOME_SUPPLIER_ATTACHMENTS = "jobincome_supplier_attachments";
export const IDENTITY_SUPPLIER_ATTACHMENTS = "identity_supplier_attachments";
export const IDENTITY_SUPPLIER_ATTACHMENTS_ID =
  "identity_supplier_attachments_id";
//income Tab
export const INCOME_RENT_ATTACHMENTS = "income_rent_attachments_id";

export const WORK_FLOW_TYPE = "work_flow_type";
// notice
export const NOTICE_FILTER = "notice_filter";

//seller
export const SELLER_GET = "seller_get";
export const SELLER_BIRTHDATE = "seller_birthdate";
export const IDENTITY_SELLER_ATTACHMENTS = "identity_seller_attachments";
export const IDENTITY_SELLER_ATTACHMENTS_ID = "identity_seller_attachments_id";
//vehicle
export const FORM_KEY = "form_key";

//payment
export const TABLE_FILTER_PAYMENT = "table_filter_payment";

//store
export const PARENT_CATEGORY_ID = "parent_category_id";
export const PARENT_CATEGORY_ID_OLD = "parent_category_id_old";
export const PRODUCT_KEY = "product_key";
export const PRODUCT_PATH = "product_path";

// costumerwhiteList
export const WHITELIST_TEMPLATES = "white_list_templates";
//sale
export const SALE_ITEM = "sale_item";
export const SALE_INVOICE_OTP = "sale_invoice_otp";
